import { render } from "./Faculties.vue?vue&type=template&id=aec02bec&scoped=true"
import script from "./Faculties.vue?vue&type=script&lang=js"
export * from "./Faculties.vue?vue&type=script&lang=js"

import "./Faculties.vue?vue&type=style&index=0&id=aec02bec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aec02bec"

export default script